import { CloseIcon, TaboolaLogoIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './valueHighlighterInstructions.module.scss';

export const ValueHighlighterInstructions = ({ onClose }) => {
    return (
        <div className={styles['container']}>
            <TaboolaLogoIcon />
            <FormattedMessage
                id="codeless.value.instructionst"
                className={styles['text']}
                defaultMessage="Select one of the highlighted elements to select the value"
            />

            <CloseIcon onClick={onClose} className={styles['close-icon']} />
        </div>
    );
};
